/*
 * Public API Surface of minimal-scrolling
 */

export * from './lib/minimal-scrollbar.service';
export * from './lib/minimal-scrollbar.component';
export * from './lib/minimal-scrollbar.module';
